import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";

import { SitesListComponent } from "./sites-list/sites-list.component";
import { SitesDetailsComponent } from "./sites-details/sites-details.component";
import { AuthGuard } from "src/app/shared/guard/auth.guard";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const sitesRoutes: Routes = [
  {
    path: "",
    component: SitesListComponent,
  },
  { path: "reset", redirectTo: "site", pathMatch: "prefix" },
  {
    path: "site",
    component: SitesDetailsComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "site/:id",
    component: SitesDetailsComponent,
    canActivate: [AuthGuard],
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(sitesRoutes)],
  exports: [RouterModule],
})
export class SitesRoutingModule {}
